import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const UserRemoveIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 8c0-2.21-1.79-4-4-4S6 5.79 6 8s1.79 4 4 4 4-1.79 4-4m3 2v2h6v-2zM2 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4"
      fill="currentColor"
    />
  </svg>
);

UserRemoveIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(UserRemoveIcon);
